import React from 'react';

const WARTELISTE_STATUS = {
  neu:            { bg: '#e3f2fd', color: '#1565c0', label: 'Neu' },
  kontaktiert:    { bg: '#fff8e1', color: '#e65100', label: 'Kontaktiert' },
  platz_angeboten:{ bg: '#e8f5e9', color: '#2e7d32', label: 'Platzangebot' },
  angenommen:     { bg: '#c8e6c9', color: '#1b5e20', label: 'Angenommen' },
  abgelehnt:      { bg: '#fce4ec', color: '#c62828', label: 'Abgelehnt' },
  storniert:      { bg: '#f5f5f5', color: '#616161', label: 'Storniert' },
};

const KONTAKT_STATUS = {
  neu:         { bg: '#e3f2fd', color: '#1565c0', label: 'Neu' },
  gelesen:     { bg: '#fff8e1', color: '#e65100', label: 'Gelesen' },
  beantwortet: { bg: '#e8f5e9', color: '#2e7d32', label: 'Beantwortet' },
  erledigt:    { bg: '#f5f5f5', color: '#616161', label: 'Erledigt' },
};

const PROBETRAINING_STATUS = {
  neu:        { bg: '#e3f2fd', color: '#1565c0', label: 'Neu' },
  terminiert: { bg: '#fff8e1', color: '#e65100', label: 'Terminiert' },
  absolviert: { bg: '#e8f5e9', color: '#2e7d32', label: 'Absolviert' },
  abgesagt:   { bg: '#fce4ec', color: '#c62828', label: 'Abgesagt' },
};

export default function StatusBadge({ status, type = 'warteliste' }) {
  const map = type === 'kontakt' ? KONTAKT_STATUS : type === 'probetraining' ? PROBETRAINING_STATUS : WARTELISTE_STATUS;
  const cfg = map[status] || { bg: '#f5f5f5', color: '#333', label: status };

  return (
    <span style={{
      backgroundColor: cfg.bg,
      color: cfg.color,
      padding: '3px 10px',
      borderRadius: '12px',
      fontSize: '0.78rem',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      display: 'inline-block',
    }}>
      {cfg.label}
    </span>
  );
}

// Antwort auf ein Platzangebot (Link in der E-Mail oder manuell eingetragen)
const PLATZANGEBOT_ZUSTAND = {
  offen:          { bg: '#fff8e1', color: '#e65100', label: 'Antwort offen' },
  angenommen:     { bg: '#c8e6c9', color: '#1b5e20', label: 'Angenommen' },
  ausgeschlagen:  { bg: '#fce4ec', color: '#c62828', label: 'Ausgeschlagen' },
  abgelaufen:     { bg: '#eceff1', color: '#546e7a', label: 'Frist abgelaufen' },
  zurueckgezogen: { bg: '#f5f5f5', color: '#616161', label: 'Zurückgezogen' },
};

export function PlatzangebotBadge({ zustand }) {
  const cfg = PLATZANGEBOT_ZUSTAND[zustand];
  if (!cfg) return null;
  return (
    <span style={{
      backgroundColor: cfg.bg, color: cfg.color, padding: '2px 8px', borderRadius: '12px',
      fontSize: '0.72rem', fontWeight: 600, whiteSpace: 'nowrap', display: 'inline-block',
    }}>
      {cfg.label}
    </span>
  );
}

export { WARTELISTE_STATUS, KONTAKT_STATUS, PROBETRAINING_STATUS, PLATZANGEBOT_ZUSTAND };
